export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";